import React from "react";

import { getNumberDayMonthYear } from "~/libs/getDateOptions";

import SrrRowBase from "./SrrRowBase";

const ReportNSByAverageCarAge = ({ row, items }) => {
  const renderItem = [
    row.client.name,
    row.vin,
    row.MKB,
    getNumberDayMonthYear({ date: row.carPurchaseDate }),
    getNumberDayMonthYear({ date: row.TO1 }),
    getNumberDayMonthYear({ date: row.TO2 }),
    getNumberDayMonthYear({ date: row.TO3 }),
    getNumberDayMonthYear({ date: row.TO4 }),
    getNumberDayMonthYear({ date: row.TO5 }),
    row.mileage,
    row.ownerChange,
    row.ownershipPeriodByChange,
    row.carPresumedSaleDate,
    row.ownershipPeriodByEPlatform,
    // row.average.carOwnershipByChange.ownershipPeriodFrom,
    // row.average.carOwnershipByChange.carsTotal,
    // row.average.carOwnershipByEPlatform.ownershipPeriodFrom,
    // row.average.carOwnershipByEPlatform.carsTotal,
    // row.average.carOwnershipByEPlatform.ownershipPeriodTo,
  ];

  return <SrrRowBase cells={renderItem} />;
};

export default ReportNSByAverageCarAge;
